<template>

    <div class="form-group row">
        <label v-bind:for="attribute"
               class="col-12 col-form-label "
               v-bind:class="[`${this.labels.css} col-md-${this.labels.width} `, orderInverse ? 'order-last' : '']">
            {{ label }}
        </label>
        <div class="col-12" v-bind:class="[`col-md-${this.widths.input} `, orderInverse ? 'order-first text-right' : '']">
            <slot></slot>

            <span v-if="attributeError" class="invalid-feedback" role="alert">
                <strong>{{ attributeError }}</strong>
            </span>
        </div>
    </div>

</template>

<script>
export default {
    name: "FormGroup",
    props: {
        attribute: {
            type: String,
        },
        label: {
            type: String,
        },
        width: {
            type: Number,
            default: 6,
        },
        inColumn: {
            type: Boolean,
            required: false,
            default: false,
        },
        orderInverse: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    mounted() {
        this.attributeError = this.errors[this.attribute] ? this.errors[this.attribute] : [''];
        this.attributeError = this.attributeError.join(`, `);
    },
    data() {
        return {
            attributeError: '',
            errors: window.data.errors,
        }
    },
    computed: {
        widths: function () {
            return {
                input: this.orderInverse ? 12 - this.width : this.width,
            }
        },
        labels: function () {
            return {
                css: this.inColumn || this.orderInverse  ? 'text-left' : 'text-md-right',
                width:
                    this.inColumn
                        ? this.width
                        : (this.orderInverse
                            ? this.width
                            : 12 - this.width),
            }
        }
    },
}
</script>

<style scoped>

</style>
